import { InitiateAuthCommand } from '@aws-sdk/client-cognito-identity-provider'
import { cognitoClient } from '@/lib/cognitoClient'
import { cognitoClientId } from '@/lib/env'
import { getTokenStore } from '@/lib/tokenStore'
import { ensure } from '@/lib/utils'

export class RefreshTokenNotExistError extends Error {
  constructor() {
    super('refresh token が存在しません')
  }
}

let refreshTokenPromise: Promise<string> | null = null

async function refreshAccessTokenInternal(): Promise<string> {
  const tokenStore = getTokenStore()
  const refreshToken = await tokenStore.getRefreshToken()
  if (!refreshToken) {
    throw new RefreshTokenNotExistError()
  }

  const authResult = await cognitoClient.send(
    new InitiateAuthCommand({
      ClientId: cognitoClientId,
      AuthFlow: 'REFRESH_TOKEN_AUTH',
      AuthParameters: { REFRESH_TOKEN: refreshToken },
    }),
  )

  const newAccessToken = ensure(authResult.AuthenticationResult?.AccessToken)
  const newRefreshToken = authResult.AuthenticationResult?.RefreshToken ?? refreshToken
  const newExpiresIn = authResult.AuthenticationResult?.ExpiresIn ?? 3600

  await tokenStore.setTokens(newAccessToken, newRefreshToken, newExpiresIn)

  return newAccessToken
}

export async function refreshAccessToken(): Promise<string> {
  refreshTokenPromise = refreshTokenPromise ?? refreshAccessTokenInternal()

  try {
    return await refreshTokenPromise
  } finally {
    refreshTokenPromise = null
  }
}
